<script lang="ts" setup>
import CreditReportFaq from "@/components/Quiz/CreditReportFaq.vue";

const props = defineProps<{ email: string, hasPcp: boolean }>()

const phrases = [
  'You have signed a contract with Johnson Law Group, a law firm regulated by the SRA, to handle your claim(s)',
  `You will receive a confirmation email at ${props.email} confirming your details`,
  'JLG will handle all legal procedures and keep you updated through the bespoke JLG Client Portal'
]
</script>

<template>
  <img src="@/assets/images/claims-unlocked.webp"
       alt="claims-unlocked"
       class="w-2/3 mx-auto py-2 mb-4"/>

  <p v-if="hasPcp" class="text-center text-xl mb-4 font-medium">
    We Found <span class="text-(--brand-primary) font-bold">4</span> potential
    claims for you<br>
    <span class="text-(--brand-primary) font-bold">1</span> DPF & <span
    class="text-(--brand-primary) font-bold">3</span> PCP!
  </p>

  <p v-if="!hasPcp" class="text-center text-xl mb-4 font-medium">
    We Found <span class="text-(--brand-primary) font-bold">3</span> potential PCP
    claims for you!
  </p>

  <p class="text-gray-600 mb-4 font-medium  text-center text-lg">
    Johnson Law Group has taken up your
    claim. No further action is required at this
    time.
  </p>

  <CreditReportFaq :phrases="phrases" class="mt-6"/>
</template>
